/*
Code for the quote carousel on the Home Page
*/

import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

import margaret from "./images/margaret.png";
import jay from "./images/jay.png";
import larkin from "./images/larkin.png";

function Quotes() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="quotes_container">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        className="quote-carousel"
        variant="dark"
      >
        <Carousel.Item>
          <div className="quotes">
            <Carousel.Caption>
              <p className="quote">
                Developing data science skills has been essential to my research
                in genomics where sophisticated statistical tools and
                programming skills are required for handling extremely large
                datasets. This foundation empowers me to pursue meaningful,
                data-driven conservation solutions for endangered species, as I
                step into the next phase of my career pursuing my PhD in
                conservation genomics.
              </p>
              <div className="attribution">
                <img src={margaret} alt="margaret" className="student_img" />
                <p className="quote-attribute">- Margaret Mattson '24</p>
              </div>
            </Carousel.Caption>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="quotes">
            <Carousel.Caption>
              <p className="quote">
                Studying data science has prompted me to be constantly curious
                and active in asking why systems exist, and how they impact
                individuals and groups. This is applicable to my diverse
                interests in education accessibility, media entertainment, and
                computer science. Being able to cite my work using computational
                and statistical tools has been an invaluable edge in industries
                that blend quantitative skillsets and creative thinking.
              </p>
              <div className="attribution">
                <img src={jay} alt="jay" className="student_img" />
                <p className="quote-attribute">- Jay Renaker '25</p>
              </div>
            </Carousel.Caption>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="quotes">
            <Carousel.Caption>
              <p className="quote">
                Now that I’m working at a software company in a non-technical
                role, my data science background helps me collaborate with
                people in technical roles effectively because we can speak the
                same language. Due to the skills and passion that the data
                science minor cultivated, I joined my company’s Machine Learning
                Ethics Committee. My understanding of Machine Learning, gained
                through my DS classes, enables me to analyze an algorithm’s
                ethical implications.
              </p>
              <div className="attribution">
                <img src={larkin} alt="larkin" className="student_img" />
                <p className="quote-attribute">- Larkin Barnard-Bahn '24</p>
              </div>
            </Carousel.Caption>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}
export default Quotes;
